import BaseService from "../BaseService";
import http from "../HttpService";
import { API_BASE_URL_ENV } from "helpers/common";

const apiEndpoint = API_BASE_URL_ENV() + "/admin/resale/resales";
const statusApi=API_BASE_URL_ENV() + "/admin/resale/toggle";
const assignSalesRepApi=API_BASE_URL_ENV() + "/admin/resale/assign-sales-rep";
const apiEndpointResaleInCompound = API_BASE_URL_ENV()+'/admin/resale/dropdown/resales-in-compound'
const apiEndpointIndependentResale = API_BASE_URL_ENV() + '/admin/resale/dropdown/independent-resales?status=Live'
export default class extends BaseService {
    constructor() {
        super(apiEndpoint);
    }
 
 
        toggleStatus=(id)=>{
        return   http.get(`${API_BASE_URL_ENV()}/admin/settings/toggle-activation/resale/${id}`)   
       }
       updateStatus=(id,data)=>{
        return http.post(`${statusApi}/${id}`, data)
       }
       getIndependentResaleDropDown = (id) => {
        return http.get(apiEndpointIndependentResale)
        }
       getResaleInCompoundDropDown = (id) => {
        return http.get(`${apiEndpointResaleInCompound}?compound_id=${id}&status=Live`)
        }
        assignSalesRep=(data)=>{
            return http.post(assignSalesRepApi, data);
        }
}
